import provideDataHook from '~/helpers/provideDataHook';
import {
  CarBrandAndCategory,
  getDataHook
} from '~/App/views/CarTreeAndCategory/CarBrandAndCategory';

export default provideDataHook(
  'HeavyTransportCategory',
  getDataHook({ mainCategory: 'heavy_transport' })
)(CarBrandAndCategory);
